import TextArea from "../../../../Components/Common/TextArea/TextArea";
import { CHAR_LIMIT } from "../../../../utils/Common/Constant";
import { SovItem } from "../types/inspector.types";

interface NotesTabProps {
  generalNotes: string;
  flagNotes: string;
  offsiteNotes: string;
  sovItems: SovItem[];
  onGeneralNotesChange: (val: string) => void;
  onFlagNotesChange: (val: string) => void;
  onOffsiteNotesChange: (val: string) => void;
}

export default function NotesTab({
  generalNotes,
  flagNotes,
  offsiteNotes,
  sovItems,
  onGeneralNotesChange,
  onFlagNotesChange,
  onOffsiteNotesChange,
}: NotesTabProps) {
  const flaggedItems = sovItems.filter((item) => item.flagged);

  return (
    <>
      <div className="notesSection">
        <div className="notesSectionTitle">General Inspection Notes</div>
        <TextArea
          className="notesArea"
          placeholder="Overall site conditions, access notes, weather, notable observations…"
          rows={5}
          value={generalNotes}
          onChange={(e) => onGeneralNotesChange(e.target.value)}
          aria-label="General inspection notes"
              maxChars={CHAR_LIMIT.DESCRIPTION}
            />
      </div>

      <div className="notesSection">
        <div className="notesSectionTitle">Flags &amp; Overbilling Notes</div>
        {flaggedItems.length === 0 ? (
          <div className="flagEmpty">No flagged items for this inspection.</div>
        ) : (
          flaggedItems.map((item) => {
            const inspectorPct =
              item.customPct !== "" ? Number(item.customPct) : item.status;
            const isAmber = item.warningLevel === "amber";
            const detail = item.warning || item.notes;
            return (
              <div
                key={item.id}
                className={`flagItem${isAmber ? " amber" : ""}`}
              >
                ⚠ {item.desc} ({item.code}): GC claims {item.claim}%
                {inspectorPct !== undefined && inspectorPct !== null
                  ? ` — CSC estimate ${inspectorPct}%`
                  : ""}
                {detail ? ` — ${detail}` : ""}
              </div>
            );
          })
        )}
        <TextArea
          className="notesArea"
          placeholder="Add additional flag notes…"
          rows={3}
          value={flagNotes}
          onChange={(e) => onFlagNotesChange(e.target.value)}
          aria-label="Flag notes"
              maxChars={CHAR_LIMIT.DESCRIPTION}
            />
      </div>

      <div className="notesSection">
        <div className="notesSectionTitle">Off-Site Stored Materials</div>
        <TextArea
          className="notesArea"
          placeholder="Notes on off-site or on-site stored materials observed…"
          rows={3}
          value={offsiteNotes}
          onChange={(e) => onOffsiteNotesChange(e.target.value)}
          aria-label="Off-site stored materials notes"
              maxChars={CHAR_LIMIT.DESCRIPTION}
            />
      </div>
    </>
  );
}
